import { render, staticRenderFns } from "./VanList.vue?vue&type=template&id=8d43c3cc&scoped=true&"
import script from "./VanList.vue?vue&type=script&lang=js&"
export * from "./VanList.vue?vue&type=script&lang=js&"
import style0 from "./VanList.vue?vue&type=style&index=0&id=8d43c3cc&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d43c3cc",
  null
  
)

export default component.exports